import * as React from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets window scroll to the top on every client-side navigation.
 *
 * react-router-dom's BrowserRouter doesn't restore or reset scroll — by
 * default a route change preserves the previous page's scroll offset,
 * so clicking a link mid-page lands the next page at the same offset.
 *
 * Skipped when the URL has a hash: the browser owns anchor jumps and
 * we shouldn't fight it (e.g. /diagnostic#start from the closer CTA).
 */
export function ScrollToTop(): null {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
